import React from 'react';
import PropTypes from 'prop-types';
import GDColorCodedCell from 'Components/GDTable/GDColorCodedCell';

const TimelineCaseCreated = (props) => {
  const {
    CurrencyCode,
    MerchantName,
    MerchantNumber,
    DocumentId,
    Documents,
    TransactionId,
    TransactionAmount,
  } = props.listItem.eventBodyDetails;
  const document = DocumentId ? 'case' : 'red';
  const merchant = MerchantNumber ? 'case' : 'red';
  const transaction = TransactionId ? 'case' : 'red';

  const renderTransaction = () => {
    return TransactionId ? (
      <>
        <h3 className="transaction-id">{TransactionId}</h3>
        <h3 className="transaction-id currency">
          {parseFloat(TransactionAmount).toFixed(2)}
          <span className="currency">{CurrencyCode}</span>
        </h3>
      </>
    ) : (
      <h3 className={`vertical-timeline-element-title ${transaction}`}>Transaction Not Automatically Attached</h3>
    );
  };

  const renderDocument = () => {
    return Documents ? (
      <h3 className={`vertical-timeline-element-title ${document}`}>{Documents}</h3>
    ) : (
      <h3 className={`vertical-timeline-element-title ${transaction}`}>Document Not Automatically Attached</h3>
    );
  };

  return (
    <div>
      <div className="content-header merchant case row">
        <div className="merchant-left">
          <div className="stage-update-label">Merchant</div>
          <h3 className={`vertical-timeline-element-title ${merchant}`}>{MerchantName || 'Merchant Not Automatically Attached'}</h3>
          {MerchantNumber && <GDColorCodedCell content={MerchantNumber} />}
        </div>
        <div className="merchant-right">
          <div className="stage-update-label">Transaction</div>
          {renderTransaction()}
        </div>
      </div>
      <hr />
      <div className="content-header merchant case row">
        <div className="merchant-left">
          <div className="stage-update-label">Document</div>
          {renderDocument()}
        </div>
      </div>
    </div>
  );
};

TimelineCaseCreated.propTypes = {
  listItem: PropTypes.object.isRequired,
};

TimelineCaseCreated.defaultProps = {

};
export default TimelineCaseCreated;
